import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, RouterEvent, Scroll } from '@angular/router';

// ionic
import { Events } from "../../helpers/events";

// rxjs
import { Subject } from "rxjs";
import { debounceTime, take, takeUntil } from "rxjs/operators";

// services
import { EventService } from "../../services/event.service";
import { UserService } from "../../services/user.service";

// models
import { Event } from "../../models/event";
import { User } from "../../models/user";

// extends
import { BasePage } from "../base";

@Component({
    selector: 'app-keywords',
    templateUrl: '../keywords/keywords.page.html',
    styleUrls: ['../keywords/keywords.page.scss'],
})

export class KeywordsPage extends BasePage implements OnInit, OnDestroy {

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * initial loading state
     *
     * @type {boolean}
     */
    public loading: boolean = true;

    /**
     * selected view
     *
     * @type {String}
     */
    public view: string = 'matching';

    /**
     * participant has some keyword setting
     *
     * @type {boolean}
     */
    public savedKeywords: boolean = false;

    /**
     * user
     *
     * @type {User}
     */
    public user: User;

    /**
     * active event for user
     *
     * @type Event
     */
    public event: Event;

    constructor(
        public appEvents: Events,
        public route: ActivatedRoute,
        public userService: UserService,
        public eventService: EventService
    ) {
        super();

        this.view = this.route.snapshot.paramMap.get('view');

        // if there is no navigation history, navigate to default page
        if (this.routerExtService.emptyHistory()) {
            // this.routerExtService.softNavigate(this.plt.defaultLink + '/keywords/' + (this.view ? this.view : ''));
        }
    }

    ngOnInit() {
        // subscribe to current user
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe((user) => {
            if (user.id) {
                this.user = user;
                this.event = this.user.selected_participant.event;
            } else {
                this.user = null;
            }
        });
        this.hideLoading();

        // check route changes to show proper view
        this.router.events.pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe(
            (navigationEvent: any) => {

                // for route event event get route event
                if ((navigationEvent instanceof Scroll)) {
                    navigationEvent = <RouterEvent>navigationEvent.routerEvent;
                }

                // using url from NavigationEnd instance, because route.snapshot was not sometimes updated...
                if (navigationEvent instanceof RouterEvent && navigationEvent instanceof NavigationEnd) {
                    let view = navigationEvent.url.split('?')[0].replace(this.plt.defaultLink + '/keywords/', '') == 'matching' ? 'matching' : 'manage-keywords';
                    // keywordSetting component monitore ngChanges on view attribute -> it will do content refresh
                    this.view = view;
                }

                // check attendee profile view
                let urlParams = new URLSearchParams(window.location.search);
                let attendeeId = urlParams.get('profile_id');
                if (attendeeId) {
                    // load event in case of need for attendee detail
                    this.eventService.getCurrentEvent().pipe(
                        take(1),
                        debounceTime(0)
                    ).subscribe(
                        (event) => {

                            // load event detail
                            this.event = event;

                            if (!this.plt.attendeeDetailOpened) {
                                this.plt.attendeeDetailOpened = true;
                                this.showAttendeeDetail(null, false, false, attendeeId);
                            }

                        });
                }
            });
    }

    public changeView(view: string) {
        if (this.view != view) {
            this.view = view;
            this.router.navigate([this.plt.defaultLink + '/keywords/' + (this.view ? this.view : '')]);
        }
        this.savedKeywords = view != 'manage-keywords';
    }

    public showAttendeeList() {
        this.router.navigate([this.plt.defaultLink + '/home/attendees/list']);
    }

    public changeLoading(value: boolean) {
        this.loading = value;
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
